// extracted by mini-css-extract-plugin
export var actions = "_4j-0";
export var actionsContainer = "_4j-6";
export var border = "_4j-1";
export var childFullHeight = "_4j-d";
export var collapse = "_4j-2";
export var content = "_4j-8";
export var contentChild = "_4j-c";
export var fullscreen = "_4j-a";
export var hasLeftRadius = "_4j-h";
export var headerContainer = "_4j-3";
export var headerRow = "_4j-5";
export var hidePadding = "_4j-9";
export var navCollapsedGap = "_4j-i";
export var noScrollX = "_4j-j";
export var noScrollY = "_4j-k";
export var optOutTopPadding = "_4j-b";
export var pageMain = "_4j-g";
export var pageOuter = "_4j-e";
export var pagePadding = "_4j-7";
export var profile = "_4j-l";
export var profileContainer = "_4j-m";
export var profileImage = "_4j-n";
export var profileMain = "_4j-o";
export var profileSubtitle = "_4j-q";
export var profileTitle = "_4j-p";
export var showLeftPadding = "_4j-f";
export var tabsWrapper = "_4j-4";
export var title = "_4j-r";